import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
const basePath = environment.basePath
@Injectable({
  providedIn: 'root'
})
export class WebRequestService {

  readonly ROOT_URL;
  constructor(private http: HttpClient) {
     this.ROOT_URL = 'localhost:3000';
   }

  get(uri: string, payload: Object){
    return this.http.get(`${basePath}/${uri}`, payload);
  }

  post(uri: string, payload: Object){
    console.log(payload)
   return this.http.post(`${basePath}/${uri}`, payload);
   }
   patch(uri: string, payload: Object){
     return this.http.patch(`${this.ROOT_URL}/${uri}`, payload);
   }

   delete(uri: string){
       return this.http.get(`${basePath}/${uri}`);
   }
}
